<app-page-wrapper title="Orders" subtitle="Manage customer and dealer orders efficiently.">
  <div class="card border-0 shadow-none">
    <div class="card-body p-3">
      <app-tab-navigation [tabs]="tabs" [selectedTab]="selectedTab" (tabChange)="selectTab($event)" />

      <ng-container [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'transporters'">
          <app-transporters />
        </ng-container>

        <ng-container *ngSwitchCase="'orders'">
          <app-orders-list />
        </ng-container>

        <ng-container *ngSwitchCase="'dispatched-orders'">
          <app-shipments />
        </ng-container>

        <ng-container *ngSwitchCase="'pending-orders'">
          <app-pending-orders />
        </ng-container>
      </ng-container>
    </div>
  </div>
</app-page-wrapper>
